
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cognitionService } from '../../cognition/cognitionService';
import type { CognitiveObject } from '../../cognition/cognitionService';

export const VotingIndexPage: React.FC = () => {
    const [objects, setObjects] = useState<CognitiveObject[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            try {
                // Fetch all objects first to ensure we see everything
                const data = await cognitionService.listObjects(undefined, undefined, 50);
                setObjects(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) return <div className="p-8 dark:text-white">Loading objects...</div>;

    return (
        <div className="p-8 max-w-4xl mx-auto dark:text-slate-200">
            <h1 className="text-2xl font-bold mb-6">Voting Logic Debug / Validation</h1>

            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 p-4 mb-6 rounded">
                <p className="text-sm text-yellow-800 dark:text-yellow-200">
                    This page exists to validate the <strong>Independent Voting UI</strong> without relying on Canvas state.
                </p>
            </div>

            <div className="space-y-4">
                {objects.length === 0 && (
                    <div className="text-gray-500 italic">No objects found in the system.</div>
                )}

                {objects.map(obj => (
                    <div key={obj.id} className="border dark:border-slate-700 p-4 rounded bg-white dark:bg-slate-800 shadow-sm flex justify-between items-center">
                        <div>
                            <div className="font-semibold text-lg">
                                {obj.content?.question || obj.id}
                            </div>
                            <div className="text-sm text-gray-500 dark:text-gray-400 flex gap-2">
                                <span className="bg-gray-100 dark:bg-slate-700 px-2 py-0.5 rounded">{obj.current_state}</span>
                                <span>v{obj.version}</span>
                                <span className="font-mono text-xs">{obj.id}</span>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate(`/voting/${obj.id}`)}
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                        >
                            Open Voting UI
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};
